<template>
  <div id="app">
      <lc-campaign-info :campaign="meeting_info"></lc-campaign-info>

      <div class="app-view">

         <h2 class="app-view-title" v-if="page_title">{{page_title}}</h2>

         {{ /* Blocking alerts */ }}
         <div v-if="error" class="alert alert-danger">{{ error }}</div>
         <div v-if="wait" class="alert alert-primary">{{ wait }}</div>
         <lc-problem-alert :message="problem"></lc-problem-alert>

         {{ /* Non-blocking alerts */ }}
         <lc-success-alert v-if="no_blocking_errors" :messages="success"></lc-success-alert>

         <router-view v-if="no_blocking_alerts"/>
      </div>
  </div>
</template>

<script>
import LcCampaignInfo from '@/components/lc-campaign-info';
import LcProblemAlert from '@/components/lc-problem-alert';
import LcSuccessAlert from '@/components/lc-success-alert';
// import {mapActions} from 'vuex';
import {mapGetters} from 'vuex';

export default {
   components: {
      LcCampaignInfo,
      LcProblemAlert,
      LcSuccessAlert
   },

   computed:{
      error (){
         return this.$store.state.error;
      },

      wait (){
         return this.$store.state.wait;
      },

      meeting_info (){
         return this.$store.state.meeting_info;
      },// /meeting_info()


      ...mapGetters([
         'error',
         'problem',
         'success',
         'wait',
         'page_title',
         'no_blocking_alerts',
         'no_blocking_errors'
      ])
   },// /computed()

   mounted (){

   }// /mounted()
};
</script>


<style lang="scss">

#app
{
   background-color: #2f323a;
   height: 100vh;
}

.app-view
{
   max-width: 50em;
   margin: auto;
   padding-top: 3em;
}
.app-header
{
   margin-bottom: 1em;
}
.campaign-info
{
   margin-bottom: 1em;
}

h2.app-view-title
{
   border-bottom: 1px solid #999999;
   padding-bottom: 0.3em;
   margin-bottom: 1em;
}
</style>
